import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { BsDownload } from "react-icons/bs";
import LottiePlayer from "lottie-react";
import axios from "axios";
import AnalyticCard from "./AnaliticCard";
import ErrorAndTakenBy from "./ErrorAndTakenBy";
import SummaryofErrors from "./SummaryofErrors";
import PredictiveDataSummery from "./PredictiveDataSummery";
import PrioritiydataSchedule from "./PrioritiydataSchedule";
import StatsLoad from "../../../../assets/animationicons/stats-load.json";
import nodatauser from "../../../../assets/images/nodatauser.svg";
import ProAnalyticsImg from "../../../../assets/images/pro/pro-analytics2.png";

const UserAnalytic = ({
  tabActiveKey,
  type = "analyticReportUser",
  userUUID,
  setToPlay,
  userReportShow = false,
  returnToUser,
  setAiPayloadData = null
}) => {
  const params = useParams();
  const moduleUUID = params?.uuid;
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [cardData, setCardData] = useState({});
  const [allIteration, setAllIteration] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentIterationUUID, setCurrentIterationUUID] = useState({});
  const userId = userUUID ? userUUID : userData.user.uuid;
  const userPlan = userData?.plans?.data || null;
  let MODE = configData.config.MODE;

  const getCardData = async () => {
    try {
      setLoading(true);
      const cardData = await axios.get(
        `${configData.config.API_URL}/api/analytics/user/module/${userId}/${moduleUUID}`,
        {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      let resData = cardData?.data?.data;
      setCardData({ ...resData });
      setAllIteration([...resData.sessions]);
      if (setAiPayloadData) {
        setAiPayloadData({
          sessions: resData?.sessions || [],
          lastSessionId: resData?.lastIteration?.uuid || ""
        })
      }
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((moduleUUID.length > 0 || tabActiveKey == "analytics") && MODE === "XR") {
      getCardData();
    }
  }, [moduleUUID, tabActiveKey]);

  // useEffect(() => {
  //     if(tabActiveKey == "analytics"){
  //         getCardData();
  //     }
  // }, [tabActiveKey]);

  const handleChangeIteration = (value) => {
    setCurrentIterationUUID({ ...value });
  };

  return (
    <div className="container grpreportpage">
      <div className="px-2 pb-3">
        {loading ? (
          <div className="load-at-analytics">
            <LottiePlayer animationData={StatsLoad} style={{ height: 150, marginBottom: 0, border: "none" }} />
            <p>Loading analytics</p>
          </div>
        ) : (
          <>
            {userReportShow && (
              <div className="row justify-content-between mb-3">
                <div className="col-8 col-md-6">
                  <div className="headdetail pt-2">
                    <span className="pagetitle cursor-pointer">
                      {userReportShow && (
                        <span onClick={returnToUser}>
                          {" "}
                          <MdOutlineArrowBack />{" "}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
                <div className="col-4 col-md-6 d-flex justify-content-end">
                  <button className="DefaultRedBtn">
                    <BsDownload /> Report
                  </button>
                </div>
              </div>
            )}
            {cardData?.sessionCounts?.all > 0 ? (
              <div className="analuticsnew ">
                <AnalyticCard cardData={cardData} setCurrentIterationUUID={handleChangeIteration} />

                {userPlan?.courseDetail?.analytics ? (
                  <>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <ErrorAndTakenBy allIteration={allIteration} />
                      </div>
                      <div className="col-md-6">
                        <SummaryofErrors currentIterationUUID={currentIterationUUID} />
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-md-6">
                        <PredictiveDataSummery
                          analytics={{
                            maxErrorProneTask: cardData.maxErrorProneTask || "",
                            maxTimeTakingTask: cardData.maxTimeTakingTask || "",
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <PrioritiydataSchedule currentIterationUUID={currentIterationUUID} />
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="for-pro">
                    <img src={ProAnalyticsImg} />
                    <span className="cover-up"></span>
                    <div className="unlock-data">
                      <h6>Unlock Features</h6>
                      <p>
                        To access these additional features, <br />
                        please <a> upgrade you plan. </a>
                      </p>
                      <button>Upgrade Plan</button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div
                  className="leaderboard-main"
                  style={{
                    backgroundColor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    backgroundImage: "none",
                    justifyContent: "center",
                  }}
                >
                  <div className=" nodatafound">
                    <div className="row justify-content-center">
                      <div className="col-md-12">
                        <img src={nodatauser} style={{ maxWidth: "60%" }} alt="" />
                        <h5 className="mb-0">No analytics data found for this module yet! </h5>
                        <p>Play the module first to view and track your progress. </p>

                        {type == "playModuleUser" && (
                          <div className="d-flex justify-content-center text-center">
                            <button className="DefaultRedBtn" onClick={setToPlay}>
                              Start Module
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UserAnalytic;
